let storeFunction = require('./configureStore.development').default;


if (process.env.NODE_ENV === 'production') {
  storeFunction = require('./configureStore.production').default;
}

let store = undefined;

module.exports.init = (initialState) => {
  store = storeFunction(initialState);
};

module.exports.getStore = () => store;
